export default __webpack_public_path__ + "static/media/doctor-banner.4a314ac9.jpg";